import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalacab() {



    const cardData = {

keyword: "Pune to Lonavala Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Lonavala Cab services for families, couples, tourists, and weekend travelers. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a smooth and enjoyable journey from Pune to the beautiful hill station of Lonavala.",

topPlaces: [
    {
        title: "Tiger Point",
        description:
            "Tiger Point is one of the most famous viewpoints in Lonavala, offering breathtaking panoramic views of the Sahyadri mountains and deep valleys. The location is especially popular during the monsoon season when the hills are covered with lush greenery and waterfalls. Visitors can enjoy spectacular sunrise and sunset views along with local snacks from nearby stalls, making it a must-visit attraction for families and nature lovers."
    },
    {
        title: "Bhushi Dam",
        description:
            "Bhushi Dam is among the top tourist attractions in Lonavala and is particularly famous during the rainy season. Water flowing over the dam's steps creates a natural water play area where visitors can relax and enjoy the cool surroundings. Surrounded by scenic hills and greenery, Bhushi Dam is a favorite destination for picnics, photography, and family outings."
    },
    {
        title: "Rajmachi Fort",
        description:
            "Rajmachi Fort is a historic hill fort located amidst the Sahyadri ranges and is a paradise for trekking enthusiasts. The fort consists of two ancient citadels and offers magnificent views of the surrounding valleys and forests. During the monsoon, the route becomes especially beautiful with waterfalls and dense greenery, attracting adventure seekers and history lovers alike."
    },
    {
        title: "Karla Caves",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves dating back more than 2,000 years and are renowned for their impressive architecture and intricate carvings. The massive prayer hall and beautifully sculpted pillars reflect India's rich cultural and religious heritage. The caves attract pilgrims, historians, and tourists from across the country."
    },
    {
        title: "Lohagad Fort",
        description:
            "Lohagad Fort is one of Maharashtra's most popular trekking destinations, known for its strong fortifications and historical significance during the Maratha Empire. The fort offers stunning views of the surrounding hills and valleys, while its famous Vinchu Kata ridge is a major attraction for trekkers and photographers."
    },
    {
        title: "Pawna Lake",
        description:
            "Pawna Lake is a picturesque destination near Lonavala famous for camping, boating, and peaceful lakeside experiences. Surrounded by hills and historic forts, the lake offers a perfect setting for family picnics, romantic getaways, and overnight camping under the stars."
    },
    {
        title: "Duke's Nose",
        description:
            "Duke's Nose is a dramatic cliff formation near Lonavala known for its unique shape and thrilling adventure activities. It is a popular spot for trekking, rock climbing, rappelling, and enjoying panoramic views of the Western Ghats and nearby valleys."
    },
    {
        title: "Ryewood Park",
        description:
            "Ryewood Park is a beautifully maintained garden in the heart of Lonavala featuring large trees, walking paths, children's play areas, and peaceful surroundings. It is an ideal place for families to relax and enjoy nature after exploring the hill station."
    },
    {
        title: "Narayani Dham Temple",
        description:
            "Narayani Dham Temple is a beautiful marble temple dedicated to Goddess Narayani and is known for its elegant architecture and serene atmosphere. Devotees and tourists visit the temple to seek blessings and experience its peaceful environment."
    },
    {
        title: "Lion's Point",
        description:
            "Lion's Point is another iconic viewpoint in Lonavala offering spectacular views of valleys, waterfalls, and rolling hills. The location becomes especially attractive during the monsoon and winter seasons, drawing visitors for sightseeing, photography, and enjoying the cool mountain climate."
    }
],



services: [
{
name: "Pune to Lonavala Cab",
description: "Rising Cab Service provides Pune to Lonavala Cab with comfortable, safe, and affordable travel for families, couples, tourists, and business travelers. Book one way or round trip cabs with professional drivers and well-maintained AC Sedan, SUV, Ertiga, and Innova Crysta vehicles for a smooth journey to Lonavala and nearby attractions."
},
{
name: "Pune to Lonavala Taxi",
description: "Book Pune to Lonavala Taxi with Rising Cab Service for reliable transportation and hassle-free travel. We offer 24x7 taxi booking, experienced chauffeurs, clean vehicles, and budget-friendly fares for sightseeing, holiday trips, and weekend getaways."
},
{
name: "Cab from Pune to Lonavala",
description: "Our Cab from Pune to Lonavala service offers convenient pickup and drop with flexible travel schedules. Enjoy safe highway travel, transparent pricing, and comfortable vehicles for solo, family, and group journeys."
},
{
name: "Taxi from Pune to Lonavala",
description: "Rising Cab Service offers Taxi from Pune to Lonavala with punctual service, verified drivers, and comfortable AC cars. Choose one way or round trip options for business travel, vacations, and local sightseeing."
},
{
name: "Pune to Lonavala Cab Service",
description: "Our Pune to Lonavala Cab Service provides affordable and premium travel solutions with Sedan, SUV, Ertiga, and Innova Crysta options. We ensure safe, comfortable, and timely transportation throughout the journey."
},
{
name: "Pune to Lonavala Taxi Fare",
description: "Get affordable Pune to Lonavala Taxi Fare with Rising Cab Service. We provide transparent pricing, competitive packages, and no hidden charges for one way, round trip, and sightseeing travel."
},
{
name: "Pune to Lonavala One Way Cab",
description: "Book Pune to Lonavala One Way Cab for convenient and budget-friendly travel without return charges. Ideal for airport transfers, business trips, and personal travel with comfortable AC vehicles."
},
{
name: "Pune to Lonavala Round Trip Taxi",
description: "Our Pune to Lonavala Round Trip Taxi service is perfect for same-day returns, family outings, and sightseeing tours with flexible waiting time and affordable travel packages."
},
{
name: "Pune to Lonavala Cab Booking",
description: "Rising Cab Service offers Pune to Lonavala Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 customer support for comfortable and reliable travel."
},
{
name: "Cheap Pune to Lonavala Cab",
description: "Choose Cheap Pune to Lonavala Cab for economical travel without compromising on comfort and safety. Our affordable cab options are ideal for students, families, and budget travelers."
},
{
name: "Best Pune to Lonavala Cab",
description: "Rising Cab Service provides the Best Pune to Lonavala Cab with premium vehicles, experienced drivers, and reliable service for comfortable and memorable journeys."
},
{
name: "One Way Pune to Lonavala Cab",
description: "Our One Way Pune to Lonavala Cab service offers affordable and flexible transportation with clean vehicles and professional chauffeurs for stress-free travel."
},
{
name: "Round Trip Pune to Lonavala Taxi",
description: "Book Round Trip Pune to Lonavala Taxi for sightseeing and holiday travel with waiting options, return journey convenience, and affordable pricing."
},
{
name: "24x7 Pune to Lonavala Cab Service",
description: "Rising Cab Service provides 24x7 Pune to Lonavala Cab Service with round-the-clock availability, instant booking, and dependable transportation for all travel requirements."
},
{
name: "Outstation Cab Pune to Lonavala",
description: "Our Outstation Cab Pune to Lonavala service ensures safe and comfortable long-distance travel with AC cars, experienced drivers, and flexible pickup and drop facilities."
},
{
name: "Pune to Khandala Cab",
description: "Rising Cab Service offers Pune to Khandala Cab for comfortable hill station travel with affordable fares, clean vehicles, and experienced drivers for one way and round trips."
},
{
name: "Pune to Khandala Taxi Service",
description: "Book Pune to Khandala Taxi Service for safe and convenient travel with multiple cab options including Sedan, SUV, Ertiga, and Innova Crysta."
},
{
name: "Pune to Khandala Cab Booking",
description: "Our Pune to Khandala Cab Booking service provides instant reservations, transparent pricing, and comfortable rides for tourists and business travelers."
},
{
name: "Best Pune to Khandala Cab",
description: "Rising Cab Service provides the Best Pune to Khandala Cab with professional drivers, premium vehicles, and reliable service for enjoyable travel."
},
{
name: "One Way Pune to Khandala Cab",
description: "Choose One Way Pune to Khandala Cab for economical and convenient travel with flexible pickup timings and comfortable vehicles."
},
{
name: "Round Trip Pune to Khandala Taxi",
description: "Book Round Trip Pune to Khandala Taxi for family outings and sightseeing tours with return journey convenience and affordable rates."
},
{
name: "Pune Airport to Lonavala Cab",
description: "Rising Cab Service offers Pune Airport to Lonavala Cab with direct airport pickup, luggage assistance, professional drivers, and comfortable vehicles for a smooth transfer."
},
{
name: "Pune Airport to Lonavala Taxi",
description: "Our Pune Airport to Lonavala Taxi service provides reliable airport transportation with 24x7 availability, affordable fares, and safe travel."
},
{
name: "Airport Cab Pune to Lonavala",
description: "Book Airport Cab Pune to Lonavala for convenient airport transfers with punctual pickup, AC vehicles, and experienced chauffeurs."
},
{
name: "Pune Airport Pickup Lonavala Cab",
description: "Rising Cab Service provides Pune Airport Pickup Lonavala Cab with hassle-free airport pickup, comfortable rides, and affordable pricing for tourists and families."
}
],

tableData: [
["Pune to Lonavala Cab","Pune to Lonavala Taxi"],
["Cab from Pune to Lonavala","Taxi from Pune to Lonavala"],
["Pune to Lonavala Cab Service","Pune to Lonavala Taxi Fare"],
["Pune to Lonavala One Way Cab","Pune to Lonavala Round Trip Taxi"],
["Pune to Lonavala Cab Booking","Cheap Pune to Lonavala Cab"],
["Best Pune to Lonavala Cab","One Way Pune to Lonavala Cab"],
["Round Trip Pune to Lonavala Taxi","24x7 Pune to Lonavala Cab Service"],
["Outstation Cab Pune to Lonavala","Pune to Khandala Cab"],
["Pune to Khandala Taxi Service","Pune to Khandala Cab Booking"],
["Best Pune to Khandala Cab","One Way Pune to Khandala Cab"],
["Round Trip Pune to Khandala Taxi","Pune Airport to Lonavala Cab"],
["Pune Airport to Lonavala Taxi","Airport Cab Pune to Lonavala"],
["Pune Airport Pickup Lonavala Cab","Hill Station Cab Pune Lonavala"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Lonavala Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Lonavala cab transportation for families, couples, tourists, corporate travelers, and weekend vacation seekers."
    },
    {
        WhyChooseheading: "Perfect for Weekend Getaways",
        WhyChoosedescription: "Lonavala is one of the most popular hill stations near Pune, making it an ideal destination for short holidays, relaxation, and sightseeing trips."
    },
    {
        WhyChooseheading: "Flexible Travel Plans for Every Traveler",
        WhyChoosedescription: "Whether planning a one-way drop, return journey, same-day sightseeing trip, or weekend tour package, we offer travel options to suit every requirement."
    },
    {
        WhyChooseheading: "Wide Selection of Comfortable Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles for a comfortable and enjoyable journey."
    },
    {
        WhyChooseheading: "Visit Popular Attractions with Ease",
        WhyChoosedescription: "Travel conveniently to Tiger Point, Bhushi Dam, Rajmachi Point, Lion's Point, Karla Caves, Bhaja Caves, and other famous attractions."
    },
    {
        WhyChooseheading: "Convenient Pickup from Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Safe and Scenic Hill Station Travel",
        WhyChoosedescription: "Our experienced drivers ensure smooth travel through ghat roads while allowing passengers to enjoy the beautiful landscapes and mountain views."
    },
    {
        WhyChooseheading: "Ideal for Families, Friends, and Couples",
        WhyChoosedescription: "Rising Cab Service caters to romantic trips, family vacations, group outings, corporate excursions, and special celebrations."
    }
]
};

const faqData = [
    {
        question: "Why is Lonavala a popular destination from Pune?",
        answer: "Lonavala is famous for its scenic hills, waterfalls, viewpoints, caves, pleasant climate, and weekend getaway attractions."
    },
    {
        question: "Can I book a one-way cab from Pune to Lonavala?",
        answer: "Yes, one-way cab services are available along with round-trip and sightseeing packages."
    },
    {
        question: "Which attractions can be covered during a Lonavala trip?",
        answer: "Popular places include Tiger Point, Bhushi Dam, Lion's Point, Rajmachi Point, Karla Caves, Bhaja Caves, and Pawna Lake."
    },
    {
        question: "Which vehicle is best for a family trip to Lonavala?",
        answer: "Ertiga and Innova Crysta are among the most preferred choices due to their spacious seating and travel comfort."
    },
    {
        question: "Do you provide Tempo Travellers for group outings?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate trips, and tourist groups."
    },
    {
        question: "Can same-day return trips be arranged?",
        answer: "Yes, many travelers choose same-day return packages for sightseeing and leisure travel."
    },
    {
        question: "Is this service suitable for corporate outings?",
        answer: "Yes, companies frequently use our Pune to Lonavala cab service for team outings, meetings, and recreational trips."
    },
    {
        question: "Can travelers customize their sightseeing itinerary?",
        answer: "Yes, customers can include preferred tourist attractions and travel stops according to their plans."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Lonavala Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Kulkarni",
        feedback:
            "Our weekend trip to Lonavala was fantastic. The cab was comfortable, the journey was smooth, and we enjoyed every sightseeing stop without worrying about transportation.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Jagtap",
        feedback:
            "A family outing to Lonavala became truly memorable thanks to Rising Cab Service. The vehicle was clean, spacious, and perfectly suited for our travel needs.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Lonavala Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-lonavala-cab.jpg",
"description": "Book Pune to Lonavala Cab Service with Rising Cab Service for safe, comfortable, and scenic hill station travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-lonavala-cab"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to Lonavala Cab Service | Hill Station Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Lonavala Cab Service for safe and comfortable hill station travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to lonavala cab, pune to lonavala taxi, cab from pune to lonavala, taxi from pune to lonavala, pune to lonavala cab service, pune to lonavala taxi fare, pune to lonavala one way cab, pune to lonavala round trip taxi, pune to lonavala cab booking, cheap pune to lonavala cab, best pune to lonavala taxi, sedan pune to lonavala cab, suv pune to lonavala taxi, innova pune to lonavala cab, hill station cab pune lonavala, Pune to Lonavala Cab, Pune to Lonavala Cab Service, Pune to Lonavala Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavalacab;